import React from 'react';
import { Button, Spinner } from 'reactstrap';

interface Props {
  onRefresh: () => Promise<unknown>;
  isRefreshing: boolean;
}

const RefreshIcon: React.FC = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable={false}
  >
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" />
    <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14" />
  </svg>
);

const RefreshButton: React.FC<Props> = ({ onRefresh, isRefreshing }) => {
  return (
    <Button
      color="link"
      type="button"
      className="p-1"
      data-testid="wearables-dashboard-refresh"
      onClick={() => {
        if (!isRefreshing) {
          void onRefresh();
        }
      }}
      disabled={isRefreshing}
      aria-busy={isRefreshing}
      aria-label="Refresh"
      title="Refresh"
    >
      {isRefreshing ? <Spinner size="sm" /> : <RefreshIcon />}
    </Button>
  );
};

export default RefreshButton;
